import { rgba } from 'polished'
import pink from '@mui/material/colors/pink'

export const width = (wSm = '90%', wMd = '85%') => ({
  marginInline: 'auto !important',
  width: {
    sm: wSm,
    md: wMd,
    xxl: 'auto'
  }
})

export const maxWidth = {
  maxWidth: 2560,
  marginInline: 'auto !important',
}

export const padding = (padVer = 0, even = false) => (even ? {
  padding: {
    xs: 2.5,
    md: 3,
  }
} : {
  paddingBlock: padVer,
  paddingInline: {
    xs: 2.5,
    md: 3,
  }
})

export const ellipsis = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const hrStyle = () => ({
  marginInline: 'auto',
  marginBlock: 7.5,
  border: 0,
  borderBottom: '1px dashed',
  borderColor: 'divider',
  width: '40%'
})

export const contentStyle = () => ({
  typography: 'body1',
  ...padding(),
  '& > h1': { typography: 'h3' },
  '& > h2': {
    fontSize: {
      xs: 'h5.fontSize',
      md: 'h4.fontSize'
    },
    fontFamily: 'fontFamilyCaption',
    fontWeight: 'unset',
    textTransform: 'uppercase',
  },
  '& > h1, & > h2': {
    marginTop: '3em',
    marginBottom: '1.33em'
  },
  '& > h3': {
    typography: 'h5',
    fontStyle: 'italic'
  },
  '& > h4, & > h5, & > h6': {
    typography: 'h6',
    fontStyle: 'italic'
  },
  '& > h3, & > h4, & > h5, & > h6': {
    marginTop: '1.67em',
    marginBottom: '1.67em'
  },
  '& > hr': hrStyle(),
  [`
    & > h1, & > h2, & > h3, & > h4, & > h5, & > h6,
    & > p, & > ul, & > ol,
    & > blockquote, & > form,
    & > section
  `]: width(),
  '& > blockquote': {
    position: 'relative',
    marginBlock: 6,
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      transform: 'translate(-40%, -35%)',
      content: 'open-quote',
      fontSize: '6em',
      color: 'divider'
    },
    '& p': {
      fontStyle: 'italic',
      color: 'text.secondary',
      paddingBlock: 0,
      paddingInline: 3
    }
  },
  '& a:not([role="button"])': {
    fontWeight: 'fontWeightMedium',
    color: pink[600]
  }
})

export const postItemRootStyle = (theme) => {
  const { mode } = theme.palette
  const { paper } = theme.palette.background
  const { black } = theme.palette.common

  return {
    display: 'block',
    borderRadius: 2,
    overflow: 'hidden',
    transition: 'ease-out 0.1s',
    transitionProperty: 'background, transform, boxShadow !important',
    '&:hover': {
      transform: 'translateY(-1px) scale(1.02)',
      background: paper,

      ...mode === 'light' ? {
        boxShadow: [
          `-8px -8px 8px ${rgba(paper, 0.3)}`,
          `8px 8px 8px ${rgba(black, 0.03)}`
        ].join(',')
      } : {},

      '& .image-bleed': {
        ...mode === 'light' ? {
          filter: 'saturate(2) brightness(1.2) blur(40px)',
          opacity: 0.175,
        } : {
          filter: 'saturate(1.5) brightness(1.2) blur(40px)',
          opacity: 0.3,
        },
        transform: 'scale(3)'
      }
    }
  }
}

export const postItemImgWrapperStyle = () => ({
  padding: 0.5,
  position: 'relative',
})

export const postItemImgBleedStyle = () => ({
  filter: 'blur(40px)',
  opacity: 0.2,
  transition: 'ease-out 0.75s',
  transitionProperty: 'opacity filter transform',
})

export const postItemImgStyle = theme => ({
  borderRadius: 1,
  position: 'absolute !important',
  width: `calc(100% - ${theme.spacing(1)})`,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
})

export const postItemInfoStyle = () => ({
  paddingBlock: 5.5,
  paddingInline: {
    xs: 3.5,
    sm: 4
  }
})

export const postItemTitleStyle = () => ({
  color: 'text.primary',
  fontWeight: 'fontWeightMedium',
  marginBottom: 2,
})

export const postItemCountryStyle = () => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  gap: '1ch',
  color: 'text.primary',
  fontSize: 'body2.fontSize',
  marginBottom: 1.5
})

export const postItemDateStyle = () => ({
  color: 'text.secondary',
  fontStyle: 'italic',
})

export const postItemFlagStyle = () => ({
  top: '-0.1em',
})
